import { Routes } from 'react-router-dom';
import LeavesList from 'domain/people/leave/List';
import { CreateLeave, UpdateLeave } from 'domain/people/leave/createupdate';
import ViewLeave from 'domain/people/leave/Show';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import BalancesListPage from './BalancesListPage';
import { GlobalProtectedRoute } from 'framework/authorization';
import LeaveContext from './LeaveContext';
import { LEAVES_LIST_SEARCH, LEAVES_CREATE, LEAVE_GET, LEAVE_UPDATE, LEAVE_EXTEND } from 'domain/shared/leave';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { LEAVE_BALANCES_PATH, LEAVE_PATH, useLeaveRoute } from 'domain/people/leave/leaveRouting';

const LeaveRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute, createRoute: createLeaveRoute, updateRoute } = useLeaveRoute();

  return (
    <ProtectedRouter basePath={LEAVE_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={LEAVES_LIST_SEARCH}>
              <LeavesList />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={createLeaveRoute}
          element={
            <GlobalProtectedRoute path={createLeaveRoute} globalPermissionToCheck={LEAVES_CREATE}>
              <CreateLeave />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <LeaveContext permissionToCheck={LEAVE_GET}>
              <ViewLeave />
            </LeaveContext>
          }
        />
        <Route
          path={updateRoute}
          element={
            <LeaveContext permissionToCheck={[LEAVE_UPDATE, LEAVE_EXTEND]}>
              <UpdateLeave />
            </LeaveContext>
          }
        />

        <Route path={LEAVE_BALANCES_PATH} element={<BalancesListPage />} />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

LeaveRouter.getRouterPath = () => `${LEAVE_PATH}/*`;

export default LeaveRouter;
